import { useFinanceiroFichasDialog } from "./use-financeiro-fichas-dialog";
import { FinanceiroFichasDialogView } from "./view-financeiro-fichas-dialog";
import type { FinanceiroFichasDialogProps } from "./types-financeiro-fichas-dialog";

export function FinanceiroFichasDialog(props: FinanceiroFichasDialogProps) {
  const vm = useFinanceiroFichasDialog(props);

  return <FinanceiroFichasDialogView {...vm} />;
}

export type * from "./types-financeiro-fichas-dialog";
